import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from 'vue-property-decorator';
import Collocation from './collocation.vue';
let goodsSalesList = class goodsSalesList extends Vue {
    get collocationInfo() {
        return this.collocationList[0];
    }
};
tslib_1.__decorate([
    Prop({ default: [] })
], goodsSalesList.prototype, "collocationList", void 0);
goodsSalesList = tslib_1.__decorate([
    Component({
        components: {
            Collocation,
        },
    })
], goodsSalesList);
export default goodsSalesList;
